import { drawCartesianAxes, seriesCategories, valueOf } from './axes.js';

function draw(chart, ctx, progress) {
  const categories = seriesCategories(chart.options.series);
  const { yToPixel, xForIndex, step } = drawCartesianAxes(chart, ctx, categories);
  const hitAreas = [];
  const seriesCount = chart.options.series.length;
  const groupPad = 0.2;
  const barW = (step * (1 - groupPad)) / seriesCount;
  const zeroY = yToPixel(0);

  chart.options.series.forEach((s, si) => {
    const color = s.color || chart.options.colors[si % chart.options.colors.length];
    s.data.forEach((d, i) => {
      const value = valueOf(d);
      const groupStart = xForIndex(i) - (step * (1 - groupPad)) / 2;
      const bx = groupStart + si * barW;
      const fullY = yToPixel(value);
      const py = zeroY - (zeroY - fullY) * progress;
      const top = Math.min(py, zeroY);
      const h = Math.abs(zeroY - py);

      ctx.fillStyle = color;
      ctx.fillRect(bx, top, barW - 2, h);

      if (chart.options.dataLabels === true && progress >= 1) {
        ctx.fillStyle = '#0F3659';
        ctx.font = 'bold 11px Arial';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'bottom';
        ctx.fillText(String(value), bx + (barW - 2) / 2, top - 4);
      }

      hitAreas.push({
        contains: (mx, my) => mx >= bx && mx <= bx + barW - 2 && my >= top && my <= top + h,
        tooltipX: bx + barW / 2,
        tooltipY: top,
        label: `<b>${s.name || 'Series ' + (si + 1)}</b><br>${typeof d === 'object' ? d.x ?? d.label : i}: ${value}`,
        raw: { seriesIndex: si, seriesName: s.name, dataIndex: i, x: typeof d === 'object' ? d.x ?? d.label : i, y: value },
      });
    });
  });

  return hitAreas;
}

const BarChart = { draw };
export default BarChart;
